//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { computed, ref } from '@vue/composition-api'
// eslint-disable-next-line object-curly-newline
import { mdiMinus, mdiPlus, mdiPause, mdiPlay } from '@mdi/js'

export default {
  setup() {
    const bpm = ref(40)
    const interval = ref(null)
    const isPlaying = ref(false)

    const color = computed(() => {
      if (bpm.value < 100) return 'primary'
      if (bpm.value < 125) return 'success'
      if (bpm.value < 140) return 'info'
      if (bpm.value < 175) return 'warning'

      return 'error'
    })

    const decrement = () => {
      bpm.value -= 1
    }

    const increment = () => {
      bpm.value += 1
    }

    const toggle = () => {
      isPlaying.value = !isPlaying.value
    }

    return {
      bpm,
      interval,
      isPlaying,
      color,
      decrement,
      increment,
      toggle,

      // icon
      icons: {
        mdiMinus,
        mdiPlus,
        mdiPause,
        mdiPlay,
      },
    }
  },
}
